import { render, staticRenderFns } from "./Invalid.vue?vue&type=template&id=81fdbdaa&"
import script from "./Invalid.vue?vue&type=script&lang=js&"
export * from "./Invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports